<div class="wrapper-list-stores wrapper-design">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Storefront" | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-4">
    <!-- One section, because these two are one choice: both answer at the store's
         address and the switches decide which. -->
    <div class="card design-panel mb-4">
      <div class="panel-glow"></div>

      <div class="panel-header d-flex align-items-center">
        <div class="panel-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="7" height="9" x="3" y="3" rx="1" />
            <rect width="7" height="5" x="14" y="3" rx="1" />
            <rect width="7" height="9" x="14" y="12" rx="1" />
            <rect width="7" height="5" x="3" y="16" rx="1" />
          </svg>
        </div>
        <div>
          <h4 class="panel-title mb-1">{{ "What your storefront shows" | translate }}</h4>
          <p class="panel-subtitle mb-0">
            {{ "Choose which one answers at your store's address." | translate }}
          </p>
        </div>
      </div>

      <div class="row">
        <!-- Classic Editor — the storefront's own home page, default until a custom one
             takes over, which is why its switch is the inverse of the next one. -->
        <div class="col-12 col-md-6 mb-3 mb-md-0">
          <div class="design-card h-100 d-flex flex-column justify-content-between">
            <div class="card-header-section p-4 pb-0">
              <div class="d-flex align-items-start justify-content-between mb-2">
                <h3 class="m-0 text-truncate" title="{{ 'Classic Editor' | translate }}">{{ "Classic Editor" | translate }}</h3>
                <span class="badge badge-primary-light m-0" *ngIf="websiteIsDefault">
                  <svg class="mr-1" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                  {{ "Default" | translate }}
                </span>
              </div>

              <p class="card-desc">
                {{ "Make quick changes to your site's appearance and content with the easy-to-use editor." | translate }}
              </p>

              <div class="switches-section py-2">
                <div class="toggle-control d-flex justify-content-between align-items-center">
                  <div class="toggle-info text-left">
                    <div class="toggle-label">{{ "Set as Default" | translate }}</div>
                    <div class="toggle-desc">{{ "Show your storefront's built-in home page" | translate }}</div>
                  </div>
                  <label class="switch-ios">
                    <input type="checkbox" [checked]="websiteIsDefault"
                      [disabled]="homePageBusy || !hasHomePage"
                      (click)="toggleDefault()" />
                    <span class="slider-ios"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="card-footer-section p-4 border-top">
              <button class="btn btn-primary-custom w-100" id="site-editor"
                [routerLink]="['/dashboard/content-editor']">
                {{ "Edit Site" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- HTML Editor — a custom HTML document answering at the same address. -->
        <div class="col-12 col-md-6">
          <div class="design-card h-100 d-flex flex-column justify-content-between">
            <div class="card-header-section p-4 pb-0">
              <div class="d-flex align-items-start justify-content-between mb-2">
                <h3 class="m-0 text-truncate" title="{{ 'HTML Editor' | translate }}">{{ "HTML Editor" | translate }}</h3>
                <span class="badge badge-primary-light m-0" *ngIf="homePageIsDefault">
                  <svg class="mr-1" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                  {{ "Default" | translate }}
                </span>
              </div>

              <p class="card-desc" *ngIf="!homePageLookupFailed">
                {{ "Write your own HTML home page to replace the one your storefront shows by default." | translate }}
              </p>
              <p class="card-desc is-error" *ngIf="homePageLookupFailed">
                <i class="fi fi-rr-exclamation mr-1"></i>
                {{ "Home page settings are unavailable on this environment." | translate }}
              </p>

              <div class="switches-section py-2">
                <div class="toggle-control d-flex justify-content-between align-items-center">
                  <div class="toggle-info text-left">
                    <div class="toggle-label">{{ "Set as Default" | translate }}</div>
                    <div class="toggle-desc">{{ "Show your custom HTML home page" | translate }}</div>
                  </div>
                  <label class="switch-ios">
                    <input type="checkbox" [checked]="homePageIsDefault"
                      [disabled]="homePageBusy || !hasHomePage"
                      (click)="toggleDefault()" />
                    <span class="slider-ios"></span>
                  </label>
                </div>

                <!-- Where it answers: one country's storefront, or all of them. -->
                <div class="country-control">
                  <label class="toggle-label" for="home-page-country">{{ "Country" | translate }}</label>
                  <select id="home-page-country" class="country-select" #homeCountry
                    [disabled]="homePageBusy || !hasHomePage || !countriesLoaded"
                    (change)="setHomePageCountry(homeCountry.value)">
                    <option value="" [selected]="homePageCountry === ''">{{ "All countries" | translate }}</option>
                    <option *ngFor="let country of storeCountries" [value]="country.code"
                      [selected]="country.code === homePageCountry">
                      {{ country.name }} ({{ country.code }})
                    </option>
                    <!-- A saved country missing from the list must still read as
                         itself, not fall back to "All countries". -->
                    <option *ngIf="homePageCountry && !countriesLoaded || homePageCountryMissing"
                      [value]="homePageCountry" selected>{{ homePageCountry }}</option>
                  </select>
                  <div class="toggle-desc is-error" *ngIf="homePageCountryMissing">
                    {{ "This country is no longer active, so your HTML home page is not showing anywhere." | translate }}
                  </div>
                  <div class="toggle-desc" *ngIf="!homePageCountryMissing">
                    {{ (homePageCountry ? "Other countries show the built-in home page." : "Shown on every country's storefront.") | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer-section p-4 border-top">
              <button class="btn btn-primary-custom w-100" id="home-page-editor" (click)="editHomePage()"
                [disabled]="homePageLoading || openingHomePage || homePageLookupFailed">
                {{ (hasHomePage ? "Edit Home Page" : "Create Home Page") | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Themes stands apart: it is not part of that choice, so it is not shaped
         like one of its cards. -->
    <div class="card themes-band d-flex align-items-center">
      <div class="themes-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z" />
          <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
          <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
          <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
          <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
        </svg>
      </div>
      <div class="themes-text flex-grow-1">
        <h3 class="m-0">{{ "Themes" | translate }}</h3>
        <p class="m-0">{{ "Pick a theme from our library and reflect your brand across the whole site." | translate }}</p>
      </div>
      <button class="btn btn-primary-custom themes-action" id="themes" [routerLink]="['/dashboard/themes']">
        {{ "Change Themes" | translate }}
      </button>
    </div>
  </div>
</div>
